import { render, staticRenderFns } from "./LabeledButton.vue?vue&type=template&id=0021cad7&scoped=true"
import script from "./LabeledButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabeledButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LabeledButton.vue?vue&type=style&index=0&id=0021cad7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0021cad7",
  null
  
)

export default component.exports